import CloseIcon from "@mui/icons-material/Close";
import { Box, Chip, IconButton, Modal, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";  
import { BIGrey, BILightGrey } from "../../assets/helpers";
import { ClientUDFieldComponent } from "../safety-observation/ClientUDFieldComponent";

function ViewClientSafetyIncident({ open, handleClose, currentSafetyIncident }) {
  const { multiLanguageData,selectedClientData } = useSelector((state) => state?.main);
    const { TEXT_DATE, TEXT_TIME, TEXT_JOB, TEXT_CLIENT_NOTIFIELD } =
      ClientEnglishFallback.ClientSaftyIncidentViewModal(
        multiLanguageData?.ClientSaftyIncidentViewModal || {}
      );

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="client-modal-responsive">
        <Stack spacing={1}>
          <Stack direction="row" sx={{ justifyContent: "flex-end" }}>
            <IconButton className="view-close" sx={{ color:selectedClientData?.AccentColor !==undefined &&selectedClientData?.AccentColor ? selectedClientData?.AccentColor : BILightGrey }} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>

          <Typography>
            <span style={{ color: BIGrey, marginRight: "8px" }}>{TEXT_DATE}</span>
            {dayjs(currentSafetyIncident.incidentDate).format("MMMM DD, YYYY")}
          </Typography>

          <Typography variant="body1">
            <span style={{ color: BIGrey, marginRight: "8px" }}>{TEXT_TIME}</span>
            {dayjs(currentSafetyIncident.incidentTime).format("hh:mm A")}
          </Typography>

          <Typography variant="body1">
            <span style={{ color: BIGrey, marginRight: "8px" }}>{TEXT_JOB}</span>
            {currentSafetyIncident.clientJobCode} - {currentSafetyIncident.clientJobName}
          </Typography>

          <Typography
            sx={{
              wordBreak: "break-all"
            }}
            variant="body1">
            {currentSafetyIncident.description}
          </Typography>
          <ClientUDFieldComponent mode="view" udFields={currentSafetyIncident?.udFieldsList} />
        </Stack>
      </Box>
    </Modal>
  );
}

export default ViewClientSafetyIncident;
